module.exports = __webpack_public_path__ + "img/r0-10.04182653.png";